import { io, Socket } from 'socket.io-client';
import * as mediasoup from 'mediasoup-client';

const getSocketHost = () => {
    const host = window.location.hostname;
    const protocol = window.location.protocol;
    const port = window.location.port ? `:${window.location.port}` : '';

    return `${protocol}//${host}${port}`;
};

// 🛡️ SECURITY UPDATE: Grab the token to pass the backend Gatekeeper
const token = localStorage.getItem('token') || '';

export const socket: Socket = io(getSocketHost(), {
    auth: { token }, // 👈 NEW: Sends JWT to backend socket authentication
    transports: ['websocket', 'polling'], // 👈 Swapped to prioritize WebSocket for WSS
    reconnection: true,
    reconnectionAttempts: 10,
    timeout: 5000,
    autoConnect: false
});

/**
 * 🛡️ UPDATE SOCKET AUTHENTICATION
 * Call this from your AuthContext when a user logs in or out 
 * to refresh the socket connection with the new token.
 */
export const updateSocketAuth = (newToken: string | null) => {
    socket.auth = { token: newToken || '' };

    if (newToken) {
        socket.connect(); 
    } else {
        socket.disconnect(); 
    }
};

export const mediasoupClient = mediasoup;

/**
 * 🚀 JOIN ROOM WRAPPER
 */
export const joinMediasoupRoom = (roomId: string, role: 'STUDENT' | 'TUTOR', userId: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        if (!socket.connected) {
            return reject(new Error("Signaling server offline. Check if backend is running."));
        }

        console.log(`📡 Handshaking with Session ID: ${roomId}`);

        socket.emit('join-room', { roomId, role, userId }, (response: any) => {
            if (response?.error) {
                console.error("❌ Access Denied:", response.error);
                reject(new Error(response.error));
            } else {
                console.log(`✅ Access Granted for Room: ${roomId}`);
                resolve(response);
            }
        });
    });
};

/**
 * 🛰️ GLOBAL KICK LISTENER
 */
socket.off('kick-student');
socket.on('kick-student', (data: { targetId: string, message: string }) => {
    const localUserId = localStorage.getItem('userId');

    if (data.targetId === localUserId) {
        alert(data.message || "Session ended. You have been redirected.");
        window.location.href = '/dashboard';
    }
});


/**
 * 🛰️ TRANSPORT HANDSHAKE WRAPPER
 */
export const connectTransport = (transportId: string, dtlsParameters: any): Promise<void> => {
    return new Promise((resolve, reject) => {
        socket.emit('transport-connect', { transportId, dtlsParameters }, (response: any) => {
            if (response.error) reject(response.error);
            else resolve();
        });
    });
};

/**
 * 📢 PRODUCE WRAPPER
 */
export const produceMedia = (transportId: string, kind: string, rtpParameters: any, roomId: string): Promise<string> => {
    return new Promise((resolve, reject) => {
        socket.emit('transport-produce', { transportId, kind, rtpParameters, roomId }, (response: any) => {
            if (response.error) reject(response.error);
            else resolve(response.id);
        });
    });
};

/**
 * 🧊 CONSUME WRAPPER
 */
export const consumeMedia = (transportId: string, producerId: string, rtpCapabilities: any, roomId: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        socket.emit('consume', { transportId, producerId, rtpCapabilities, roomId }, (response: any) => {
            if (response.error) reject(response.error);
            else resolve(response);
        });
    });
};

// --- Debug Listeners ---
socket.on('connect', () => {
    console.log(`🔌 Connected to Backend Signaling at ${getSocketHost()}`);
});

socket.on('connect_error', (err: any) => {
    console.error("🚨 Socket Connection Error:", err.message);
});